module.exports = __webpack_public_path__ + "static/media/siddhi_pawar.1ce6ba63.png";